export default __webpack_public_path__ + "static/media/cloud.3de210d4.svg";